module.exports = __webpack_public_path__ + "static/media/deng1.5fbe2563.png";